export const WARNING_STRINGS = {
	SHIELD_ALT: 'Escudo webmotors',
	HEADING: 'Dica de segurança Webmotors',
	TEXT: 'A pessoa está pedindo um dado seu, PINs, senhas, códigos ou seu número de telefone? Desconfie! Passar dados pessoais pode expor você a fraudes. Lembre-se: utilize sempre o Chat seguro Webmotors e cuidado com os espertinhos!',
} as const;
